/**
 * @param value
 * @returns {boolean}
 */
export const searchOptionsHideShow = (value) => {
    const container = document.querySelector('#additionalSearchPanel')
    if (container === null) {
      return false
    }
    const searchOptionBtn = document.querySelector('#searchOptionsBtn');

    const showHideSearchSection = (e) => {
        e.stopPropagation();       
        if(container.classList.contains('searchOptionStateHide')){
            $(container).addClass('searchOptionStateShow');
            $(container).removeClass('searchOptionStateHide');
            searchOptionBtn.innerText="Fewer search options"
        }else{
            $(container).addClass('searchOptionStateHide');
            $(container).removeClass('searchOptionStateShow')
            searchOptionBtn.innerText="More search options "
        }
        
      }

      searchOptionBtn.addEventListener('click', (e) => showHideSearchSection(e))
}